export default {
    light: {
        primary: '#b1e3f2',
        secondary: '#b1e3f2',
        error: '#e94948',
        warning: '#ffb74d',
        info: '#64b5f6',
        success: '#81c784',
        dark: '#212121', // 100%
        divider: '#000000' // 12%
    },
    main: {
        primary: '#00A3D9',
        secondary: '#005B86',
        error: '#b00020',
        warning: '#ff9800',
        info: '#2196f3',
        success: '#4caf50',
        dark: '#212121', // 60%
        divider: '#000000' // 8%
    },
    dark: {
        primary: '#005384',
        secondary: '#005c86',
        error: '#790000',
        warning: '#f57c00',
        info: '#1976d2',
        success: '#388e3c',
        dark: '#212121', //30%
        divider: '#000000' // 8%
    }
}